<template>
  <div>
    <div v-if="$route.query.styleB && $route.name == 'Gen2DocumentViewer' || $route.name == 'PublicDocumentViewer'" class="mb-3">
      <div class="vx-row mt-n3">
        <div class="vx-col self-center w-full">
          <div class="vx-row">
            <div class="vx-col self-center w-1/5 center-v-h">
              <p class="gen2-large-numbers text-white">{{ $route.query.lpNumber }}</p>
            </div>
            <div class="vx-col self-center w-3/5 text-left">
              
            </div>
            <div class="vx-col self-center w-1/5 center-v-h">
              <custom-svg variant="arrow" width="40" height="40" dir="down" color="white" />
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mt-n3">
        <div class="vx-col self-center w-full">
          <div class="vx-row">
            <div class="vx-col self-center w-1/6">
              <feather-icon icon="CodesandboxIcon" class="text-white" svg-classes="stroke-current h-10 w-10"></feather-icon>
            </div>
            <div class="vx-col self-center w-5/6 text-left self-center lp-name">
              <h4 class="w-full">
                <span>{{ $route.query.lpName }}&nbsp;</span>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="numPages" id="zoom-slider" class="flex" :class="{'fixed': $route.name != 'Gen2DocumentViewer' && $route.name != 'PublicDocumentViewer', 'relative': $route.name == 'Gen2DocumentViewer' || $route.name == 'PublicDocumentViewer'}">
      <feather-icon id="zoom-out-icon" class="mr-3 cursor-pointer" icon="MinusIcon" svg-classes="stroke-current" @click="zoomLevel >= 20 ? zoomLevel = zoomLevel - 10 : zoomLevel = zoomLevel"></feather-icon>
      <vs-slider :min="10" :max="100" :step="10" v-model="zoomLevel"/>
      <feather-icon id="zoom-in-icon" class="ml-3 cursor-pointer" icon="PlusIcon" svg-classes="stroke-current" @click="zoomLevel <= 90 ? zoomLevel = zoomLevel + 10 : zoomLevel = zoomLevel"></feather-icon>
      <span class="ml-4 text-white h-auto self-center"><strong>{{zoomLevel}}%</strong></span>
    </div>
    <div v-if="numPages" id="zoom-slider_mobile">
      <feather-icon id="zoom-out-icon" class="mr-3 cursor-pointer" icon="MinusIcon" svg-classes="stroke-current" @click="zoomLevel >= 20 ? zoomLevel = zoomLevel - 10 : zoomLevel = zoomLevel"></feather-icon>
      <feather-icon id="zoom-in-icon" class="ml-3 cursor-pointer" icon="PlusIcon" svg-classes="stroke-current" @click="zoomLevel <= 90 ? zoomLevel = zoomLevel + 10 : zoomLevel = zoomLevel"></feather-icon>
      <span class="ml-4 text-white h-auto self-center"><strong>{{zoomLevel}}%</strong></span>
    </div>
    <div v-if="scrollable" :style="{ 'max-width': zoomLevel + '%' }" :class="{ 'pt-16': $route.name != 'Gen2DocumentViewer' && $route.name != 'PublicDocumentViewer', 'pt-3': $route.name == 'Gen2DocumentViewer' || $route.name == 'PublicDocumentViewer' }">
      <vs-progress v-if="!numPages" :height="6" indeterminate color="success"></vs-progress>
      <div v-if="downloadable && $route.name != 'Gen2DocumentViewer' && $route.name != 'PublicDocumentViewer'" id="paging-buttons_container">
        <div style="position:relative;min-height:100%;">
          <div style="position: absolute;bottom: 155px;left: 0;right: 0;">
            <vx-card id="paging-card_scroll">
              <div class="vx-row mx-auto">
                <div class="vx-col w-full">
                  <div class="flex justify-center" style="align-items: baseline;">
                    <span><vs-button icon-pack="feather" icon="icon-download" color="success" radius @click="download" /></span>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
      <div id="pdf-element" v-if="numPages">
        <pdf
          ref="pdf"
          v-for="(_page, index) in numPages"
          :key="index"
          :src="documentUrl"
          :page="_page"
          @link-clicked="linkClicked($event)"
        ></pdf>
      </div>
    </div>
    <div v-else :style="{ 'max-width': zoomLevel + '%' }" :class="{ 'pt-16': $route.name != 'Gen2DocumentViewer' && $route.name != 'PublicDocumentViewer', 'pt-3': $route.name == 'Gen2DocumentViewer' || $route.name == 'PublicDocumentViewer' }">
      <vs-progress v-if="loadedRatio != 1" :height="6" :percent="Math.floor(loadedRatio * 100)" color="success"></vs-progress>
      <div id="paging-buttons_container" v-if="$route.name != 'Gen2DocumentViewer' && $route.name != 'PublicDocumentViewer'">
        <div id="prev-btn_container">
          <vs-button id="prev-page-btn" @click="page > 1 ? prevPage():''" size="large" radius icon-pack="feather" v-show="page != 1" icon="icon-arrow-left" />
          </div>
        <div id="next-btn_container">
          <vs-button id="next-page-btn" @click="page <= numPages-1 ? nextPage() : '' " size="large" radius icon-pack="feather" v-show="page != numPages" icon="icon-arrow-right" />
        </div>
        <div style="position:relative;min-height:100%;">
          <div style="position: absolute;bottom: 200px;left: 0;right: 0;">
            <vx-card id="paging-card">
              <div class="vx-row mx-auto">
                <div class="vx-col w-full">
                  <div class="flex justify-center" style="align-items: baseline;">
                    <span v-if="downloadable" class="mr-3"><vs-button icon-pack="feather" icon="icon-download" color="success" radius @click="download" /></span>
                    <vs-input size="small" type="number" style="width:60px" v-model.number="page" />
                    <span class="text-white" style="font-size: 12pt;" :style="{ 'margin-bottom': downloadable ? '5px' : '3px' }">&nbsp;/&nbsp;<strong>{{numPages}}</strong></span>
                    <!-- <span v-if="downloadable" class="ml-2"><vs-button icon-pack="feather" icon="icon-printer" color="primary" radius @click="$refs.pdf.print()" /></span> -->
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
      <div :style="{ 'max-width': zoomLevel + '%', 'height': '100%'}" v-touch:swipe="swipeHandler" class="relative">
        <div id="paging-buttons_container__mobile" v-if="$route.name == 'Gen2DocumentViewer' || $route.name == 'PublicDocumentViewer'">
          <div class="relative" style="height: 100%;">
            <div class="page-btn_container__mobile page-prev">
              <div style="height:100%;width:100%" class="relative">
                <vs-button id="prev-page-btn__mobile" @click="page > 1 ? prevPage():''" size="large" radius icon-pack="feather" v-show="page != 1" icon="icon-arrow-left" />
              </div>
            </div>
            <div class="page-btn_container__mobile page-next">
              <div style="height:100%;width:100%" class="relative">
                <vs-button id="next-page-btn__mobile" @click="page <= numPages-1 ? nextPage() : '' " size="large" radius icon-pack="feather" v-show="page != numPages" icon="icon-arrow-right" />
              </div>
            </div>
            <div style="left: 0;right: 0;">
              <vx-card id="paging-card__mobile">
                <div class="vx-row mx-auto">
                  <div class="vx-col w-full">
                    <div class="flex justify-center" style="align-items: baseline;">
                      <vs-input size="small" type="number" style="width:60px" v-model.number="page" />
                      <span class="text-white" style="font-size: 12pt;align-self: flex-end;">&nbsp;/&nbsp;<strong>{{numPages}}</strong></span>
                    </div>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        <pdf 
          id="pdf-element"
          ref="pdf"
          :src="documentUrl"
          :page="page"
          :rotate="rotate"
          @progress="loadedRatio = $event"
          @error="error"
          @num-pages="numPages = $event"
          @link-clicked="page = $event"
        ></pdf>
      </div>
    </div>

    <div v-if="!onlyPdfViewer">
      <div v-show="!onlyContent" class="fab_direction-up" :class="$siteTypeId() == 1 ? 'block-important' : ''">
        <div class="float-btn-group">
          <button class="btn-float btn-triger school-primary_gradient glow-effect_primary" @click="openActions">
            <i class="icon feather icon-more-horizontal text-white" />
          </button>
          <div class="btn-list">
            <a v-if=" (!$isProductionEnv()) || ($isProductionEnv() && [21,24].includes($getSiteId()))" class="btn-float dc_dark-purple description glow-effect_dark" @click="showQaPopup">
              <span class="descriptiontext">{{ "Ask a Question" }}</span>
              <i class="icon feather icon-help-circle text-white"></i>
            </a>
            <a class="btn-float dc_dark-purple description glow-effect_dark" @click="backToTopic">
              <span class="descriptiontext">Go back to tasks</span>
              <i class="icon feather icon-arrow-up text-white"></i>
            </a>
            <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="nextTask" @click="next">
              <span class="descriptiontext">NEXT</span>
              <i class="icon feather icon-arrow-right text-white" />
            </a>
            <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="prevTask" @click="previous">
              <span class="descriptiontext">PREVIOUS</span>
              <i class="icon feather icon-arrow-left text-white" />
            </a>
          </div>
        </div>
      </div>
      <!-- <div class="completebuttonstylebdocument" v-if="$siteTypeId() != 1"> -->
      <div :class="{ 'completebuttonstylebdocument': $route.name != 'Gen2DocumentViewer' && $route.name != 'PublicDocumentViewer', 'completebuttonstylebdocument_sonke': $route.name == 'Gen2DocumentViewer' || $route.name == 'PublicDocumentViewer' }" v-if="$siteTypeId() != 1 && showCompleteBtn && ($route.query.styleB || $acl.check('Student')) && numPages">
        <div class="flex next_btns__container justify-center">
          <vs-button id="completetask-btn" class="vs-con-loading__container next_btns clickbuttonactive"
            :style="{ 'z-index': $route.name == 'Gen2DocumentViewer' || $route.name == 'PublicDocumentViewer' ? '0' : '10000' }"
            ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
            @click="completedNowProceed">
            Complete
          </vs-button>
        </div>
      </div>

      <vs-popup 
        title="Cannot Continue"
        id="formative-assessments-marked-popup" 
        :active.sync="isTaskBlocked">
        <p class="pb-2">Well done on completing your Formative Assessments! Your answers will be assessed by a registered Assessor. You will receive a notification regarding the outcome.</p>
        <div class="mt-3">
          <vs-button color="success" class="float-right" @click="isTaskBlocked = false">Go to Dashboard</vs-button>
        </div>
      </vs-popup>
    </div>
    <vs-popup 
      title="Ask a question"
      :active.sync="isQaPopupActive">
        <q-a
        :isActive = isQaPopupActive
      />
    </vs-popup>
  </div>
</template>

<script>
import 'animate.css';
import { uuid } from 'vue-uuid';
import pdf from 'vue-pdf'
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import QA from '../components/q-a/QA.vue'
export default {
  components: {
    pdf,
    CustomSvg,
    QA
  },
  data() {
    return {
      queue: [],
      uuid: "",
      logData: {},
      fabElement: null,
      document: {},
      documentUrl: "",
      onlyContent : false,
      backgroundCardHeight: 0,
      backgroundCardWidth: 0,
      standaloneContentDto: {},
      selectedData: {},
      topicName: '',
      index: null,
      currentTask: null,
      nextTask: null,
      prevTask: null,
      navigateByChoice: false,
      isTeacher: false,
      moduleId: 0,
      isStudentLocal: false,
			numPages: undefined,
			loadedRatio: 0,
			page: 1,
			rotate: 0,
      isTaskBlocked: false,
      onlyPdfViewer: false,
      scrollable: false,
      downloadable: false,
      zoomLevel: 100,
      showCompleteBtn: false,
      isQaPopupActive:false,
      isUserPremium: false,
      onSuccessForUserCheck: false,
      startCourseTaskLog: false,
      selectedGrade:{},
      premiumResponse:{},
      activeSubscription:{},
      selectedDataMounted:{},
    };
  },
  watch:{
    isTaskBlocked: function(){
      var self = this;
      if(!self.isTaskBlocked)
      {
        self.backToDashboard();
      }
    },
  },
  methods: {
    linkClicked(event) {
      // alert(event);
    },
    error: function(err) {

			console.log(err);
    },
    prevPage() {
      this.scrollToNavbar();
      this.page = this.page - 1;
    },
    nextPage() {
      this.scrollToNavbar();
      this.page = this.page + 1;
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    backToTopic() {
      var self = this;
      self.navigateByChoice = false;
      if (self.$route.query.ref == "resources") {
        if (self.isTeacher) {
          self.$router.push({ name: 'TeacherResources'});
        } else if (self.isStudentLocal) {
          self.$router.push({ name: 'StudentAdditionalResources'})
        }
      } else {
        if(self.selectedData.selectedTopic && self.isTeacher)
          self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else if(self.selectedData.selectedTopic && self.isStudentLocal)
          self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else
          self.$router.push({ name: 'StudentRoster'});
      }
    },
    completedNowProceed(){
      var self = this;

      if (self.$acl.check('Student')) {
        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = null;
        self.logData.taskId = self.$route.query.id;
        self.logData.toTaskId = null;
        
        var onSuccess = function () {
          self.backToDashboard();
        };
        self.$ajaxPost(self, "DocumentTask/EndLogEntry", self.logData, onSuccess);
      } else {
        self.backToDashboard();
      }
    },
    backToDashboard(){
      var self = this;
      self.navigateByChoice = true;
      setTimeout(() => {
        if (self.$route.query.lpName) {
          var lpId = self.$route.query.moduleId;
          var lpName = self.$route.query.lpName;
          var lpNumber = self.$route.query.lpNumber;
          var selectedModule = self.$route.query.selectedTaskGroup;
          var selectedOutcome = self.$route.query.selectedOutcome;
          var timeCapture = self.$route.query.timeCapture ? JSON.parse(self.$route.query.timeCapture) : {};

          if (self.$route.query.outcome) {
            self.$router.push({ name: self.$route.name == 'PublicDocumentViewer' ? "PublicOutcomeTasks" : "Gen2OutcomeTasks", query: { moduleId: lpId, lpName: lpName, lpNumber: lpNumber, selectedTaskGroup: selectedModule, selectedOutcome: selectedOutcome, timeCapture: JSON.stringify(timeCapture) } });
          } else {
            self.$router.push({ name: self.$route.name == 'PublicDocumentViewer' ? "PublicStudentDashboard" : "Gen2LearningPrograms", query: { ref: "continue", id: lpId }, params: { lp: {moduleId: lpId, moduleName: lpName, lpNumber: lpNumber}, selectedTaskGroup: selectedModule } });
          }
        } else {
          self.$router.push({ name: "LearningStyleBViewer", params: { moduleId: self.moduleId, checkTimeCapture: true }});
        }
      }, 69);
    },
    next() {
      var self = this;
      self.url = "";
      self.index += 1;
      self.page = 1;
      if(self.index >= self.standaloneContentDto.tasks.length){
        self.backToTopic()
        return;
      }
      var data = {
        selectedData: self.selectedData,
        standaloneContentDto: self.standaloneContentDto,
        index: self.index
      }

      localStorage.setItem("lastKnownTopic", JSON.stringify(data));
      
      if(self.nextTask) {
        self.closeActions();
        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.toTaskId = self.nextTask.id;
        if(self.$route.params.styleB){
          var onSuccess = response => {
            this.backToTopic();
          }
          this.$ajaxPost(self,"DocumentTask/EndLogEntry", self.logData, onSuccess)
        }
        else{
          self.enqueue("DocumentTask/EndLogEntry", self.logData);
        }
        self.currentTask = self.nextTask;
        
        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;

        self.nextTask = self.index + 1 <= self.standaloneContentDto.tasks.length ? self.standaloneContentDto.tasks[self.index + 1] : null;
        self.prevTask = self.standaloneContentDto.tasks[self.index - 1];

        self.logData.fromTaskId = (self.prevTask ? self.prevTask.id : null);

        if(self.currentTask.document && self.currentTask.document.id) {
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.navigateByChoice = false;
            self.document = self.currentTask.document;
            self.showDocument();

            self.enqueue("DocumentTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
          {
            self.navigateByChoice = false;
            self.document = self.currentTask.document;
            self.showDocument();

            self.enqueue("DocumentTask/StartLogEntry", self.logData);
          }
          else 
          {
            self.showPremiumContentPopup();
          }
        }
        else if(self.currentTask.video && self.currentTask.video.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null),
              activeSubscription:self.activeSubscription,
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if(self.currentTask.podcast && self.currentTask.podcast.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PodcastViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null),
              activeSubscription:self.activeSubscription,
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "LiveStreamViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoChatPage",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.upload && self.currentTask.upload.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "UploadViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null),
              activeSubscription:self.activeSubscription,
            }
          });
        }
        else if (self.currentTask.presentation && self.currentTask.presentation.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PresentationViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.quiz && self.currentTask.quiz.id){
          this.getQuizTask(self.currentTask.quiz.id, self.selectedData.selectedTopic.id);
        }
      }
    },
    getQuizTask(taskId, moduleId) {
      var self = this;
      var onSuccess = function (response) {
        self.navigateByChoice = false;
        self.$router.push({ name: "QuizTaskViewer", params: {
          taskId: taskId,
          moduleId: moduleId,
          quiz: response.data,
        }});
      };
      var onFinally = function(response) {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };
      self.$ajaxGet(self, "Student/GetQuizTask?moduleId=" + moduleId + "&quizTaskId=" + taskId, onSuccess, onFinally);
    },
    previous() {
      var self = this;
      self.url = "";
      self.index = --self.index;
      self.page = 1;

      if(self.index < 0){
        self.backToTopic();
        return;
      }
      
      var data = {
        selectedData: self.selectedData,
        standaloneContentDto: self.standaloneContentDto,
        index: self.index
      }

      localStorage.setItem("lastKnownTopic", JSON.stringify(data));
      
      if(self.prevTask) {
        self.closeActions();

        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.toTaskId = self.prevTask.id;
        self.enqueue("DocumentTask/EndLogEntry", self.logData);

        self.currentTask = self.prevTask;

        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;

        self.nextTask = self.standaloneContentDto.tasks[self.index + 1];
        self.prevTask = self.index > 0 ? self.standaloneContentDto.tasks[self.index - 1] : null;

        self.logData.fromTaskId = (self.nextTask ? self.nextTask.id : null);

        if(self.currentTask.document && self.currentTask.document.id) {
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.navigateByChoice = false;
            self.document = self.currentTask.document;
            self.showDocument();

            self.enqueue("DocumentTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
          {
            self.navigateByChoice = false;
            self.document = self.currentTask.document;
            self.showDocument();

            self.enqueue("DocumentTask/StartLogEntry", self.logData);
          }
          else 
          {
            self.showPremiumContentPopup();
          }
        }
        else if(self.currentTask.video && self.currentTask.video.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null),
              activeSubscription:self.activeSubscription,
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if(self.currentTask.podcast && self.currentTask.podcast.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PodcastViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null),
              activeSubscription:self.activeSubscription,
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "LiveStreamViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null),
              activeSubscription:self.activeSubscription,
            }
          });
        }
        else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoChatPage",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null),
              activeSubscription:self.activeSubscription,
            }
          });
        }
        else if (self.currentTask.upload && self.currentTask.upload.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "UploadViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null),
              activeSubscription:self.activeSubscription,
            }
          });
        }
        else if (self.currentTask.presentation && self.currentTask.presentation.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PresentationViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
      }
    },
    showDocument() {
      var self = this;
      self.documentUrl = self.document.url;

      if (self.scrollable) {
        var loadingTask = pdf.createLoadingTask(self.documentUrl);

        loadingTask.promise.then(pdf => {

          self.numPages = pdf.numPages;
        });
      }
    },
    resizeCard() {
      this.backgroundCardWidth = window.innerWidth * 0.966;
      this.backgroundCardHeight = window.innerHeight * 0.755;

      if(this.vimeoPlayer) {
        this.vimeoPlayer.element.height = this.backgroundCardHeight;
        this.vimeoPlayer.element.width = this.backgroundCardWidth;
      }
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle('open')
      }
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove('open')
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    enqueue(messageType, logPayload) {
      this.queue.push({
        type: messageType,
        payload: {
          logIdentifier: logPayload.logIdentifier.toString(),
          toTaskId: logPayload.toTaskId,
          fromTaskId: logPayload.fromTaskId,
          taskId: logPayload.taskId,
        }
      })
    },
    dequeue() {
      return this.queue.shift();
    },
    startProcessor() {
      var self = this;
      var onSuccess = function (response) {
        var next = self.dequeue();
        if (next)
          self.process(next, onSuccess);
      };
      setInterval(function () {
        if (self.queue.length > 0) {
          self.process(self.dequeue(), onSuccess)
        }
      }, 3000)
    },
    process(queueItem, successFunc) {
      var self = this;
      if (queueItem) {
        self.$ajaxPost(self, queueItem.type, queueItem.payload, function(response){
          self.showCompleteBtn = true;
          successFunc();
        });
      }
    },
    getIsTaskBlocked(){
      var self = this;

      if(self.$route.query.taskClassificationTypeId == 2 && self.$acl.check("Student")){
        var studentId = localStorage.getItem("Current_User_Id");
        var onSuccess = function(response){
          self.isTaskBlocked = response.data == 2 ||  response.data == 1 ? true : false;
        } 
        self.moduleId = self.$route.query.moduleId;
        self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.moduleId, onSuccess)
      }
    },
    swipeHandler(direction) {
      var self = this;
      switch (direction) {
        case "left":
          if (self.page <= (self.numPages - 1)) {
            self.nextPage();
          }
          break;
        case "right":
          if (self.page > 1) {
            self.prevPage();
          }
          break;
        default:
          break;
      }
      console.log(direction);
    },
    download() {
      window.open(this.documentUrl, '_blank');
    },
    checkIfPdfHasLoaded() {
      var isCanvasEmpty = true;

      while (isCanvasEmpty) {
        var canvas = document.getElementsByTagName('canvas');
        if (canvas && this.numPages) {
          const context = canvas[0].getContext('2d');

          const pixelBuffer = new Uint32Array(
            context.getImageData(0, 0, canvas[0].width, canvas[0].height).data.buffer
          );

          isCanvasEmpty = !pixelBuffer.some(color => color !== 0);
          console.log("Canvas is empty");
        }
      }
      
    },
    closeQaPopup(){
      var self = this;
      self.isQaPopupActive = false;
    },
    showQaPopup(){
      var self = this;
      self.isQaPopupActive = true;
    },
    getIsUserPremium(onComplete){
      var self = this;
      if(!self.currentTask || this.$getSiteId() != self.$VUE_APP_SITE_WITH_CONTENT){
        onComplete();
        return;
      }
      if(!self.currentTask.isPremium){
        onComplete();
        return;
      }
      if(!self.$route.params.activeSubscription){
        onComplete();
        return;
      }
      self.activeSubscription = self.$route.params.activeSubscription;
      self.premiumResponse = self.activeSubscription;
      if(!self.currentTask.isPremium){
        onComplete();
        return
      }
      if(self.currentTask.isPremium && self.premiumResponse.subscriptionTypeId == 1){
        self.showPremiumContentPopup();
        return
      }
      else if(self.currentTask.isPremium && self.premiumResponse.subscriptionTypeId > 1){
        
        if(self.premiumResponse.preElective || self.premiumResponse.preElective == 0 ){
          var onSuccess = response =>{
            if(response.data){
              onComplete();
            }
            else{
              self.showPremiumContentPopup();
            }
          }
          self.$ajaxGet(self, `public/caniaccess?taskId=${self.currentTask.id}&premiumGrade=${self.premiumResponse.preElective}` , onSuccess,);
        }
        else{
          if((self.premiumResponse.subjectIds && self.selectedDataMounted.selectedSubject && (self.premiumResponse.subjectIds.includes(self.selectedDataMounted.selectedSubject.id)))){
            onComplete();
            return
          }
        }
      }
      else{
        self.showPremiumContentPopup();
      }
    },
    checkSelectedGrade(premiumGrade){
      var self = this;
      
      premiumGrade = premiumGrade.toString();
      if(!self.selectedGrade.name){
        var selectData = localStorage.getItem('lastKnownTopic');
        var parsedData = JSON.parse(selectData);
        if(parsedData.selectedData){
          self.selectedGrade = parsedData.selectedData.selectedGrade;
        }
      }
      if(!self.selectedGrade.name){
        self.selectedGrade = localStorage.getItem('selectedGrade');
        if(self.selectedGrade){
          self.selectedGrade = JSON.parse(self.selectedGrade);
        }
      }
      if(self.selectedGrade && self.selectedGrade.name){
        var grade = self.selectedGrade.name.replace(/[^0-9]/g,'');
        if(grade.length > 2 ){
          if(premiumGrade.length == 2){
            if(grade.substring(0, 2) == premiumGrade){
              return true;
            }
          }
          if(premiumGrade.length == 1){
            if(grade.substring(0, 2) == (`0${premiumGrade}`)){
              return true;
            }
          }
        }
        if(grade.length == 2 && premiumGrade.length == 1){
          if(premiumGrade.length == 2){
            if(grade == premiumGrade){
              return true;
            }
          }
          if(premiumGrade.length == 1){
            if(grade == (`0${premiumGrade}`)){
              return true;
            }
          }
        }
        return false
      }
      if(premiumGrade){
        var canContinue = self.checkIfInCorrectGrade(premiumGrade);
        setTimeout(() => {
          return canContinue;
        }, 1000);
      }
      else{
        return false;
      }
      
    },
    checkIfInCorrectGrade(premiumGrade){
      var self = this;

      var onSuccess = response =>{
        return response.data;
      }
    
      self.$ajaxGet(self, `public/caniaccess?taskId=${self.currentTask.id}&premiumGrade=${premiumGrade}` , onSuccess,);
    },
    showPremiumContentPopup() {
      var self = this;
      self.$swal({
        title: 'Cannot Continue',
        icon: 'warning',
        backdrop: true,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Subscribe',
        html: `This is a premium task. <br> To access this content you have to be a <strong>premium subscriber</strong>.`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-border ml-3',
        },
        showClass: {
          popup: 'animate__animated animate__tada',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) { // <-- if confirmed
          window.open("/subscriptions");
        }
        else{
          self.backToTopic();
        }
      });
    },
  },
  beforeDestroy() {
    var self = this;
    if(self.startCourseTaskLog){
      if(!self.navigateByChoice) {
      self.logData.logIdentifier = self.uuid;
      self.logData.fromTaskId = self.currentTask.id;
      self.logData.taskId = self.currentTask.id;
      self.logData.toTaskId = null;
      self.enqueue("DocumentTask/EndLogEntry", self.logData);
      }
    }
  },
  mounted() {
    var self = this;
    var selectedDataLocal = localStorage.getItem('selectedData');
    self.selectedDataMounted = JSON.parse(selectedDataLocal);
    self.uuid = self.$uuid.v4();
      // self.checkIfPdfHasLoaded();
    self.$store.dispatch("updateTheme", "dark");
    var selectData = localStorage.getItem('lastKnownTopic');
    if(selectData){
      var dataObject = JSON.parse(selectData);
      self.index = dataObject.index;
      if(self.index < 0)
        self.index = 0;
      self.selectedData = dataObject.selectedData;
      if(self.selectedData.selectedTopic)
        self.topicName = self.selectedData.selectedTopic.name;
      else
        self.topicName = "Back to My Roster";
      self.standaloneContentDto = dataObject.standaloneContentDto;
      if (self.standaloneContentDto.tasks.length > self.index + 1)
        self.nextTask = self.standaloneContentDto.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];
      if (self.index > 0)
        self.prevTask = self.standaloneContentDto.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];
      self.currentTask =  self.standaloneContentDto.tasks.filter(function(item) { return item.index == self.index })[0];
      localStorage.setItem("tid", self.currentTask.id);
    }
    if(self.$route.params.activeSubscription){
      self.activeSubscription = self.$route.params.activeSubscription;
      self.premiumResponse = self.activeSubscription;
    }
    if(Object.keys(this.$route.params).length != 0){
      self.index = self.$route.params.index;
      self.currentTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0];
    }
    var onComplete = response => {
      if (self.$route.query.orig && (self.$route.query.orig == 'media' || self.$route.query.orig == 'q&a' || self.$route.query.orig == 'lib' || self.$route.query.orig == 'mod')) {
        self.onlyPdfViewer = true;
        self.document = {};  
        self.document.url = self.$route.query.url; 
        self.showDocument();
        return;
      } else if (self.$route.query.ref && self.$route.query.ref == 'resources') {
        self.onlyPdfViewer = true;
      }
      
      if(self.$route.query.styleB){
        self.getIsTaskBlocked();
      }else{
        self.isTaskBlocked = false;
      }

      if(!self.isTaskBlocked){
        self.startProcessor();
        self.resizeCard();
        self.$nextTick(() => {
          window.addEventListener('resize', () => {
            self.resizeCard();
          });
        });

        self.isTeacher = self.$acl.check("Teacher");

        self.isStudentLocal = self.$acl.check("Student");

        if (Object.keys(self.$route.query).length != 0 && Object.keys(this.$route.params).length == 0) {
          if(self.$route.query.id){
            self.moduleId = self.$route.query.moduleId;
            localStorage.setItem("moduleId", self.moduleId);

            if(!localStorage.getItem("userInfo")) {
              document.cookie = "autoRedirect="+ JSON.stringify({url: "DocumentViewer", id: self.$route.query.id});
              window.location.replace("/login");
            }

            var success = (res) => {
              self.onlyContent = true;
              self.document = {};  
              self.document.url = res.data.documentUrl; 
              self.scrollable = res.data.scrollable;
              self.downloadable = res.data.downloadable;
              if (self.downloadable) {
                self.$emit("toggleDownloadButton", true, self.document.url);
              } else {
                self.$emit("toggleDownloadButton", false);
              }

              self.showDocument();
              self.logData.taskId = self.$route.query.id;
              localStorage.setItem("tid", self.$route.query.id);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
              if(self.moduleId)
                self.enqueue("DocumentTask/StartLogEntry", self.logData);
            };

            try{
              self.$ajaxGet(self, "DocumentTask/GetDocumentByTaskId/" + self.$route.query.id, success);
            } catch{} 
          }
        }
        else {
          if(Object.keys(this.$route.params).length != 0){
            self.index = self.$route.params.index;

            self.currentTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0];

          self.document = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0].document;
          self.scrollable = self.document.scrollable;
          self.downloadable = self.document.downloadable;
          if (self.downloadable) {
            self.$emit("toggleDownloadButton", true, self.document.url);
          } else {
            self.$emit("toggleDownloadButton", false);
          }

            if (self.$route.params.standaloneContent.tasks.length > self.index + 1)
              self.nextTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];

            if (self.index > 0)
              self.prevTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];

            self.standaloneContentDto = self.$route.params.standaloneContent;
            if(self.$route.params.selectedData)
              self.selectedData = self.$route.params.selectedData;

            var data = {
              selectedData: self.selectedData,
              standaloneContentDto: self.standaloneContentDto,
              index: self.index
            }

            localStorage.setItem("lastKnownTopic", JSON.stringify(data));

            if(self.selectedData.selectedTopic)
              self.topicName = self.selectedData.selectedTopic.name;
            else
              self.topicName = "Back to My Roster";
            if(!self.isUserPremium  && !self.currentTask.isPremium)
            {
              self.startCourseTaskLog = true;
              self.showDocument();
              self.logData.taskId = self.currentTask.id;
              localStorage.setItem("tid", self.currentTask.id);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
              self.enqueue("DocumentTask/StartLogEntry", self.logData);
            }
            else if(self.$store.state.aclSubscription.status.includes("PremiumContent")){
              self.startCourseTaskLog = true;
              self.showDocument();
              self.logData.taskId = self.currentTask.id;
              localStorage.setItem("tid", self.currentTask.id);
              self.logData.logIdentifier = self.uuid;
              self.logData.toTaskId = null;
              self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
              self.enqueue("DocumentTask/StartLogEntry", self.logData);
            }
            else{
              self.showPremiumContentPopup();
            }
            
          }
          else {
            if (self.isStudentLocal) {
              self.$router.push({ name: 'StudentRoster' });
            }
            else {
              self.$router.push({ name: 'BrowseContent' });
            }
          }

          if (self.$route.query.scrollable) {
            self.scrollable = self.$route.query.scrollable;
          }
        }
      }
    }
    this.getIsUserPremium(onComplete);

  }
};
</script>

<style lang="scss">
.next_btns__container {
  .next_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }

  #completetask-btn {
    // z-index: 10000;
    width: 225px !important;
    border-radius: 25px !important;
    background-image: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  }
}

  .contentCards {
    margin: auto;
  }

  .fab_direction-up__three-items {
    right: 70px;
    bottom: 4vh;
    z-index: 11000!important;
    position: fixed;
  }
  .fab_direction-up {
    right: 70px;
    bottom: 4vh;
    z-index: 11000!important;
    position: fixed;
  }
.block-important{
  display: block !important;
}

.button-center-bottom{
  position:relative !important;
  top:100% !important;
  width:260px !important;
  background: rgb(43,55,43) !important;
  background: linear-gradient(266deg, rgba(43,55,43,1) 0%, rgba(68,198,70,1) 78%) !important;
  &:hover{
    cursor: pointer;
  }
}

.completebuttonstylebdocument{
  padding: 2rem 0rem 10rem 0rem !important;
}

.completebuttonstylebdocument_sonke{
  padding: 2rem 0rem 1rem 0rem !important;
}

#pdf-element {
  canvas {
    border-radius: 25px;
  }
  >span {
    margin-bottom: 1.3rem;
  }
}

.content-wrapper {
  overflow: hidden !important;
}
</style>
